import { createFileRoute, Outlet } from '@tanstack/react-router';
import { AppShell } from '@/components/layout/AppShell.tsx';
import { requireSignedIn } from '@/lib/route-guards.ts';

/** Pathless layout for the office screens: sign-in required, sidebar shell. */
export const Route = createFileRoute('/_app')({
  beforeLoad: ({ context, location }) => requireSignedIn(context, location),
  component: AppLayout,
});

function AppLayout() {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
